export function deepEqual(left, right, strict = false) {
  if (typeof left !== typeof right) return false

  if (typeof left !== 'object') return left === right

  if (Array.isArray(left))

    if (!Array.isArray(right)) return false

    else left.every((item, index) => deepEqual(item, right[index]))

  const rightIsEqualLeft = Object.keys(left).every((key) => deepEqual(left[key], right[key], strict))

  if (!rightIsEqualLeft) return false

  if (!strict) return true

  return Object.keys(right).every((key) => deepEqual(left[key], right[key], strict))
}
